/* eslint-disable */

import React, { useState, useEffect, useMemo } from 'react';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import client from '../../api/client';
import ReactPaginate from 'react-paginate';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import CardProduct from '../../components/card/card-product/CardProduct';
import './MarketPlace.css';
import BtnGogo from '../../components/buttongoto/ButtonGoto';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function sortShopItems(items) {
  const p1 = items.filter((item) => Number(item.first_pricenew > 0));
  const p2 = items.filter(
    (item) => Number(item.first_pricenew) === 0 && item.ads === true,
  );
  const p3 = items.filter(
    (item) => Number(item.first_pricenew) === 0 && item.ads === false,
  );
  return p1.concat(p2).concat(p3);
}

function ShopSeller(props) {
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();

  const isShopLoggedIn =
    props.permitdata &&
    props.permitdata.role !== 'guest' &&
    props.permitdata.token &&
    props.permitdata.token !== '-';
  const isJobOnlyLoggedIn =
    sessionStorage.getItem('meya-job-loggedin') === 'true' && !isShopLoggedIn;
  const [view_defaultpaginate, setDefaultPaginate] = useState(0);
  const [view_productcategory_name, setView_productcategory_name] = useState('');
  const [view_shop_code, setView_shop_code] = useState('');
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  useEffect(() => {
    const shopcode = searchParams.get('shopcode');
    const category = searchParams.get('category');
    if (shopcode !== '') {
      setView_shop_code(shopcode);
      setView_productcategory_name(category);
    }
    setItemOffset_onsell(0);
    setDefaultPaginate(0);
  }, [location]);

  const shopItemsQuery = useQuery({
    queryKey: ['shop-items', view_shop_code],
    queryFn: async () => {
      await sleep(200);

      const formData = new FormData();
      formData.append('shop_seller', view_shop_code);

      const response = await client.post('/api/market/itemlist/byshopid', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });

      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'byshopid failed');
        err.isWarning = true;
        throw err;
      }

      return {
        items: sortShopItems(response.data.items ?? []),
        shopinfo: response.data.shopinfo ?? {},
      };
    },
    enabled: view_shop_code !== '',
  });

  const dataitem_all = shopItemsQuery.data?.items ?? [];
  const view_shop_info = shopItemsQuery.data?.shopinfo ?? {};

  const dataitem_filter_single = useMemo(() => {
    if (view_productcategory_name === 'รวมสินค้า') {
      return dataitem_all;
    }
    if (view_productcategory_name !== '' && view_productcategory_name !== 'รวมสินค้า') {
      if (view_productcategory_name === 'สินค้าโปรโมชั่น') {
        return dataitem_all.filter((item) => Number(item.first_pricenew) > 0);
      }
      if (view_productcategory_name === 'สินค้าแนะนำ') {
        return dataitem_all.filter((item) => item.ads === true);
      }
      const findcatid = props.systemdata_productcategorylist.find(
        (item) => item.productcategory_name === view_productcategory_name,
      );
      const catid = findcatid !== undefined ? findcatid.productcategory_id : '';
      return dataitem_all.filter((item) => item.productcategory_id === catid);
    }
    return [];
  }, [view_productcategory_name, props.systemdata_productcategorylist, dataitem_all]);

  useEffect(() => {
    if (shopItemsQuery.isFetching && !shopItemsQuery.data) {
      setmodal_load({ enable: true, message: 'กำลังโหลดรายการสินค้า' });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [shopItemsQuery.isFetching, shopItemsQuery.data]);

  useEffect(() => {
    if (!shopItemsQuery.isError) return;
    const isWarning = shopItemsQuery.error?.isWarning;
    setmodal_load({ enable: false, message: '' });
    setModal_popup({
      modaltype: isWarning ? 'modal-warning' : 'modal-error',
      headers: isWarning ? 'ขออภัย' : 'ผิดพลาด',
      message: shopItemsQuery.error?.message ?? 'ผิดพลาด',
      enable: true,
    });
  }, [shopItemsQuery.isError, shopItemsQuery.error]);

  const [itemOffset_onsell, setItemOffset_onsell] = useState(0);
  const endOffset_onsell = itemOffset_onsell + 18;
  const currentItems_onsell = dataitem_filter_single.slice(itemOffset_onsell, endOffset_onsell);
  const pageCount_onsell = Math.ceil(dataitem_filter_single.length / 18);
  const handlePageClick_onsell = (event) => {
    const newOffset_onsell = (event.selected * 18) % dataitem_filter_single.length;
    setItemOffset_onsell(newOffset_onsell);
    setDefaultPaginate(event.selected);
  };

  return (
    <main id='content' role='main' className='marketplace-container'>
      <div className='container'>
        <div className='row mb-8'>
          {/* Sidebar */}
          <div className='d-none d-lg-block marketplace-sidebar px-1'>
            <div className='sidebar-card'>
              <div className='sidebar-title font-th'>
                <i className='fe-package text-primary'></i> หมวดหมู่สินค้าในร้าน
              </div>
              <ul className='sidebar-nav-list'>
                <li className='sidebar-nav-item'>
                  <Link
                    to={
                      '/marketplace/shopseller?shopcode=' + view_shop_code + `&category=รวมสินค้า`
                    }
                    className={
                      'sidebar-nav-link font-th ' +
                      (view_productcategory_name === 'รวมสินค้า' ? 'active' : '')
                    }
                  >
                    <span>สินค้าในร้านทั้งหมด</span>
                  </Link>
                </li>
                <li className='sidebar-nav-item'>
                  <Link
                    to={
                      '/marketplace/shopseller?shopcode=' +
                      view_shop_code +
                      `&category=สินค้าโปรโมชั่น`
                    }
                    className={
                      'sidebar-nav-link font-th ' +
                      (view_productcategory_name === 'สินค้าโปรโมชั่น' ? 'active' : '')
                    }
                  >
                    <span>สินค้าโปรโมชั่น</span>
                  </Link>
                </li>
                <li className='sidebar-nav-item'>
                  <Link
                    to={
                      '/marketplace/shopseller?shopcode=' + view_shop_code + `&category=สินค้าแนะนำ`
                    }
                    className={
                      'sidebar-nav-link font-th ' +
                      (view_productcategory_name === 'สินค้าแนะนำ' ? 'active' : '')
                    }
                  >
                    <span>สินค้าแนะนำ</span>
                  </Link>
                </li>
                {props.systemdata_productcategorylist.map((element) => (
                  <li key={element.productcategory_id} className='sidebar-nav-item'>
                    <Link
                      to={
                        '/marketplace/shopseller?shopcode=' +
                        view_shop_code +
                        '&category=' +
                        element.productcategory_name
                      }
                      className={
                        'sidebar-nav-link font-th ' +
                        (view_productcategory_name === element.productcategory_name ? 'active' : '')
                      }
                    >
                      <span>{element.productcategory_name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main Content Area */}
          <div className='col d-block min-height-600 meya-content-100p market-content-card'>
            {/* Breadcrumbs */}
            <div className='mb-4 d-none d-md-block'>
              <nav aria-label='breadcrumb'>
                <ol className='breadcrumb bg-transparent p-0 mb-0'>
                  <li className='breadcrumb-item font-th'>
                    <Link to='/marketplace?category=รวมสินค้า' className='text-muted'>
                      หน้าแรก
                    </Link>
                  </li>
                  <li className='breadcrumb-item font-th text-muted'>
                    ร้านค้า
                  </li>
                  <li className='breadcrumb-item font-th active text-primary'>
                    ร้าน {view_shop_info.shop_name}
                  </li>
                </ol>
              </nav>
            </div>

            {/* Shop Banner */}
            <div className='d-block shop-banner px-3 py-4 mb-4' style={{ background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <div className='d-block py-0'>
                <h4 className='font-th text-dark mb-2 font-weight-bold' style={{ color: '#0f172a' }}>
                  {view_shop_info.shop_name}
                </h4>
                <h6 className='d-none d-md-block font-th text-muted mb-2 font-weight-normal' style={{ color: '#64748b' }}>
                  ร้านขายยาจากเว็บไซต์ มียา.com เชื่อถือได้และพร้อมจัดส่งทั่วประเทศ
                </h6>
                <p className='font-th text-primary mb-0 font-weight-bold' style={{ fontSize: '0.9rem' }}>
                  <i className='fe-package mr-1'></i> มีสินค้าในร้าน {dataitem_all.length} รายการ
                </p>
              </div>
            </div>

            {isJobOnlyLoggedIn ? (
              <div
                className='font-th mb-4 p-4 d-flex align-items-start'
                style={{
                  background: '#fff',
                  border: '1px solid #e2e8f0',
                  borderLeft: '4px solid #34a6f7',
                  borderRadius: '12px',
                  gap: '16px',
                }}
              >
                <div style={{ background: '#e0f2fe', padding: '10px', borderRadius: '12px' }}>
                  <i className='fas fa-info-circle' style={{ color: '#34a6f7', fontSize: '22px' }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h5 className='font-weight-bold mb-1' style={{ fontSize: '17px' }}>
                    บัญชีหางานยังไม่สามารถดูสินค้าได้
                  </h5>
                  <p className='mb-3' style={{ fontSize: '14.5px', color: '#64748b', lineHeight: '1.6' }}>
                    คุณสามารถดูข้อมูลร้านได้ แต่การดูสินค้าและสั่งซื้อต้องเข้าสู่ระบบด้วยบัญชีร้านค้า
                  </p>
                  <button
                    type='button'
                    className='btn text-white font-weight-bold px-4 py-2'
                    style={{
                      background: '#34a6f7',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '14px',
                    }}
                    onClick={() => {
                      sessionStorage.removeItem('meya-job-loggedin');
                      sessionStorage.removeItem('meya-job-username');
                      window.location.href = '/';
                    }}
                  >
                    เข้าสู่ระบบบัญชีร้านค้า
                  </button>
                </div>
              </div>
            ) : (
              <>
            {/* Product Section Title & Count */}
            <div className='market-section-header mt-2'>
              <h5 className='market-section-title'>
                {view_productcategory_name === 'สินค้าโปรโมชั่น' ? (
                  'สินค้าโปรโมชั่น'
                ) : view_productcategory_name === 'สินค้าแนะนำ' ? (
                  'สินค้าแนะนำ'
                ) : (
                  `หมวดหมู่สินค้า : ${view_productcategory_name}`
                )}
              </h5>
              <span className='text-muted font-th font-size-14'>
                {dataitem_filter_single.length} รายการ
              </span>
            </div>

            {/* Product Grid */}
            <div className='product-grid mt-4'>
              {currentItems_onsell.map((element) => (
                <CardProduct
                  key={element.productitem_id}
                  app_hostname={props.app_hostname}
                  shopitem={element}
                  show_stock={true}
                  show_shop={false}
                  disableLink={false}
                />
              ))}
            </div>

            {/* Pagination */}
            {pageCount_onsell > 1 && (
              <div className='modern-pagination-container mt-5'>
                <ReactPaginate
                  breakLabel='...'
                  nextLabel='>'
                  onPageChange={handlePageClick_onsell}
                  pageRangeDisplayed={5}
                  pageCount={pageCount_onsell}
                  previousLabel='<'
                  renderOnZeroPageCount={null}
                  forcePage={view_defaultpaginate}
                  containerClassName='modern-pagination'
                />
              </div>
            )}

            {/* Empty State */}
            {currentItems_onsell.length === 0 && modal_load.enable === false && (
              <div className='noproductdisplay py-5 text-center'>
                <i className='fas fa-info-circle text-primary mb-3' style={{ fontSize: '2rem' }}></i>
                <div>
                  {(() => {
                    if (
                      view_productcategory_name !== 'รวมสินค้า' &&
                      view_productcategory_name !== 'สินค้าโปรโมชั่น' &&
                      view_productcategory_name !== 'สินค้าแนะนำ' &&
                      view_productcategory_name !== 'ค้นหาสินค้า'
                    ) {
                      const category = props.systemdata_productcategorylist.find(
                        (item) => item.productcategory_name === view_productcategory_name,
                      );

                      if (category && !props.buyer_category.includes(category.productcategory_id)) {
                        return `กรุณาติดต่อ Line @meya หากต้องการเพิ่มสิทธิ์การเข้าถึงหมวดหมู่ ${category.productcategory_name}`;
                      }
                    }
                    return 'ไม่มีรายการสินค้าที่จะแสดง ลองค้นหาใหม่อีกครั้ง';
                  })()}
                </div>
              </div>
            )}
              </>
            )}
          </div>
        </div>
      </div>
      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
      <BtnGogo></BtnGogo>
    </main>
  );
}

export default ShopSeller;
